import { useEffect, useState } from "react";
import { useForm } from "@mantine/form";
import {
  TextInput,
  Text,
  Paper,
  Group,
  Button,
  Divider,
  PasswordInput,
  Checkbox,
  Anchor,
  Stack,
  Container,
  Center,
  Loader,
} from "@mantine/core";
import { GoogleButton } from "../GoogleButton";
import { TwitterButton } from "../TwitterButton";
import { fetchInvite, userConfirmation } from "../api";
import { useStore } from "../store";
import { Link, useLocation } from "wouter";
import { socialLoginFactory } from "./socialLogin";

export default function InvitationForm({ params, ...props }) {
  const [invitation, setInvitation] = useState(null);

  const form = useForm({
    initialValues: {
      realm: "PromptShuttle",
      password: "",
      emailAddress: "",
      // firstName: "",
      terms: false,
      invitationToken: "",
    },
    validate: {
      emailAddress: (val) => (/^\S+@\S+$/.test(val) ? null : "Invalid email"),
    },
  });

  const authToken = useStore((state) => state.authToken);
  const setAuthToken = useStore((state) => state.setAuthToken);
  const [, setLocation] = useLocation();

  const socialLogin = socialLoginFactory((event) => {
    setAuthToken(event.data.token);
    setLocation("/home");
  });

  useEffect(() => {
    if (authToken) setLocation("/home");
  }, [authToken, setLocation]);

  useEffect(() => {
    fetchInvite(params.token).then((data) => {
      form.setFieldValue("invitationToken", data.token);
      form.setFieldValue("emailAddress", data.emailAddress);
      setInvitation(data);
    });
    // Mantine form object has unstable identity; including it would rerun this effect every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.token]);

  return (
    <Container size="sm" mt="xl">
      <Paper radius="md" p="xl" withBorder {...props}>

        {!invitation && (<Center><Loader size="xl" mt="xl" /></Center>)}

        {invitation && (
          <Text my="md">
            You have been invited to join {invitation.inviterName}'s space on
            PromptShuttle. Create an account now using
          </Text>
        )}

        <Group grow mb="md" mt="md">
          <GoogleButton
            onClick={() => socialLogin("Google", params.token)}
            radius="xl"
          >
            Google
          </GoogleButton>
          <TwitterButton disabled radius="xl">
            X / Twitter
          </TwitterButton>
        </Group>

        <Divider
          label="Or set a password to log in with email"
          labelPosition="center"
          my="lg"
        />

        <form
          onSubmit={form.onSubmit((values) => {
            userConfirmation(values).then(() => {
              setLocation("/auth/login");
            });
          })}
        >
          <Stack>
            {/* <TextInput
              required
              label="First Name"
              placeholder="John"
              value={form.values.firstName}
              onChange={(event) =>
                form.setFieldValue("firstName", event.currentTarget.value)
              }
              radius="md"
            /> */}

            <TextInput
              label="Email"
              disabled
              value={form.values.emailAddress}
              radius="md"
            />

            <PasswordInput
              required
              label="Password"
              placeholder="Choose a new password"
              value={form.values.password}
              onChange={(event) =>
                form.setFieldValue("password", event.currentTarget.value)
              }
              error={form.errors.password}
              radius="md"
            />

            <Checkbox
              required
              // label="I accept terms and conditions"
              label={
                <>
                  I accept the{" "}
                  <Anchor
                    target="_blank"
                    href="https://www.promptshuttle.com/Legal"
                    inherit
                  >
                    terms and conditions
                  </Anchor>
                </>
              }
              checked={form.values.terms}
              onChange={(event) =>
                form.setFieldValue("terms", event.currentTarget.checked)
              }
            />
          </Stack>

          <Group justify="space-between" mt="xl">
            <Anchor href="/auth/login" component={Link} c="dimmed" size="xs">
              Already have an account? Login!
            </Anchor>
            <Button disabled={!invitation} type="submit" radius="xl">
              Register
            </Button>
          </Group>
        </form>
      </Paper>
    </Container>
  );
}
